import { defineMessages } from 'react-intl';

export default defineMessages({
  resetPasswordSuccessTitle: {
    id: 'accountSignin.resetPassword.requestSuccess.title',
    defaultMessage: 'Forgot password - Success',
    description: 'Page title for start of forgot password flow',
  },
  resetPasswordTitle: {
    id: 'accountSignin.resetPassword.title',
    defaultMessage: 'Forgot password - Create new password',
    description: 'Page title for forgot password flow after email is sent',
  },
  resetPasswordHeading: {
    id: 'accountSignin.resetPasswordHeader.heading',
    defaultMessage: 'Create new password',
    description: 'Primary heading for reset password page',
  },
  resetPasswordEnterPasswordTest: {
    id: 'accountSignin.resetPasswordColumn.enterPasswordText',
    defaultMessage: 'Create a new password for your Starbucks account.',
    description: 'Description of password reset requirement',
  },
  resetPasswordSubmit: {
    id: 'accountSignin.resetPasswordColumn.submit',
    defaultMessage: 'Save password',
    description: 'Button text for persisting new password form.',
  },
  resetPasswordSuccess: {
    id: 'accountSignin.resetPassword.success',
    defaultMessage: 'Your password has been updated',
    description: 'Text when password was successfully updated',
  },
  resetPasswordSuccessSignin: {
    id: 'accountSignin.resetPassword.success.signin',
    defaultMessage: 'Sign in',
    description: 'Button text offering Sign in options upon reset',
  },
  resetPasswordError: {
    id: 'accountSignin.resetPassword.error',
    defaultMessage: 'Password reset failed',
    description: 'Text on password reset error notification',
  },
  resetPasswordMissing: {
    id: 'accountSignin.resetPassword.missingPassword',
    defaultMessage: 'Add password',
    description: 'Text on password input when password was not supplied',
  },
});
